module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labelName))]), _vm._v(" "), _c('l-input', {
    ref: "input",
    attrs: {
      "placeholder": _vm.placeholder,
      "value": _vm.value,
      "error": _vm.error,
      "j": _vm.error,
      "isCheck": _vm.isCheck
    },
    on: {
      "input": function($event) {
        return _vm.updateValue()
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-267190ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/form_group.vue
// module id = 1282
// module chunks = 162